import { DataType } from "../../../../models/queries/queries.models";
import { DateExpressionParser } from "../../../../configuration/date-expressions";
var InitFilterValueConverter = /** @class */ (function () {
    function InitFilterValueConverter() {
    }
    InitFilterValueConverter.prototype.toView = function (value, format) {
        return this.convert(value, format);
    };
    InitFilterValueConverter.prototype.fromView = function (value, format) {
        return this.convert(value, format);
    };
    InitFilterValueConverter.prototype.convert = function (value, format) {
        var result = value;
        switch (format) {
            case DataType.Number:
            case DataType.Double:
                var regexObject = new RegExp("[-+]?[0-9]*\.?[0-9]+");
                if (value != null && regexObject.test(value.toString())) {
                    return Number(value);
                }
                else if (typeof value !== "number") {
                    result = 0;
                }
                break;
            case DataType.Boolean:
                if (typeof value !== "boolean") {
                    result = false;
                }
                break;
            case DataType.Date:
            case DataType.DateTime:
                if (value === null) {
                    return value;
                }
                if (value && DateExpressionParser.isValidExpression(value)) {
                    result = value;
                }
                else if (typeof value !== "object" || !(value instanceof (Date))) {
                    //fix app freezing because in date picker date keeps changing to current date and time
                    var date = new Date().setSeconds(0, 0);
                    result = typeof value === "string" ? new Date(value) : new Date(date);
                }
                break;
            case DataType.Lookup:
            case DataType.HeiricalLookup:
                break;
            case DataType.Default:
                if (value === undefined) {
                    result = "";
                }
                break;
            default:
                if (typeof value !== "string" && value) {
                    result = "";
                }
                break;
        }
        return result;
    };
    return InitFilterValueConverter;
}());
export { InitFilterValueConverter };
